import { mapState } from "vuex";
import { _tenant, _USER, _GAME, _GAMES } from '@/state'
import { AxiosFacade } from "@/util/AxiosFacade";
import { ziggyGetRoute } from '@/router/ziggyGetRoute';
import { outboundGetData } from '@/util/outboundGetData';

// Mixin
export const appMixin = {
	data: () => ({
		appInfo: {
			name: "Outbound",
			company: "Why Bravo"
		},
		timeouts: {
			totalRefresh: 20000,
			resourceRefresh: 7000,
			waitForLoad: 3500
		},
		appImages: {},
		// APi
		AxiosFacade,
	}),
	mounted() {
		this.appImages = {
			banner: this.staticData('images.banner') || '/images/Outbound-Virtual-Banner.png',
			logo: this.staticData('images.logo') || '/images/Outbound-logo-white.svg',
			icon: this.staticData('images.icon') || '/images/Outbound-logo-cube.svg',
		}
	},
	computed: {
		...mapState({
			showAppLoader: state => state.showAppLoader,
			_NAV: state => state.nav,
			tenant: state => state.tenant.current,
			_TENANT: state => state.tenant._current,
			user: state => state.auth.user.current,
			_USER: state => state.auth.user._current,
			games: state => state.games.all,
			_GAMES: state => state.games._all,
			game: state => state.games.current,
			_GAME: state => state.games._current,
		}),
		tenantImages() {
			var logo = this.tenant.logo_url || this.appImages.logo
			var icon = this.tenant.icon_url || this.appImages.icon
			return { logo, icon }
		}
	},
	methods: {
		// Get named route with Ziggy
		getRoute(name, params = {}) {
			if (name.substr(0, 9) == '{tenant}.') {
				return this.tenantRoute(name.replace('{tenant}.', ''), params)
			}
			return ziggyGetRoute(name, params)
		},
		// Route
		tenantRoute(name, params = {}) {
			let userTenant = _tenant();
			if (!name || !userTenant) {
				return '';
			}
			params.tenant = userTenant.slug;
			return ziggyGetRoute(name, params);
		},
		// Static Data
		staticData(key) {
			return outboundGetData(key);
		}
	}
}